import { ComponentRenderLocation } from "@intelligems/ig-types/schemas/analytics/graphs";
import {
  GraphConfig,
  GraphType,
} from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { IgBarChartSkeleton } from "@src/features/analytics/baseDashboard/chartSkeletons/IgBarChartSkeleton";
import { IgHistogramChartSkeleton } from "@src/features/analytics/baseDashboard/chartSkeletons/IgHistogramChartSkeleton";
import { IgHorizStackedBarChartSkeleton } from "@src/features/analytics/baseDashboard/chartSkeletons/IgHorizStackedBarChartSkeleton";
import { IgSankeyChartSkeleton } from "@src/features/analytics/baseDashboard/chartSkeletons/IgSankeyChartSkeleton";
import { IgStackedAreaChartSkeleton } from "@src/features/analytics/baseDashboard/chartSkeletons/IgStackedAreaChartSkeleton";
import { TimeSeriesSkeleton } from "@src/features/analytics/metricDetails/timeSeries/TimeSeriesSkeleton";

interface ChartSkeletonWrapperProps {
  config: GraphConfig;
  renderLocation?: ComponentRenderLocation;
}

export const ChartSkeletonWrapper = ({
  config,
  renderLocation,
}: ChartSkeletonWrapperProps) => {
  const useLargeDataset = renderLocation === "sitewide";

  switch (config.graphType) {
    case GraphType.Histogram:
      return <IgHistogramChartSkeleton />;
    case GraphType.Line:
      return <TimeSeriesSkeleton useLargeDataset={useLargeDataset} />;
    case GraphType.Sankey:
      return <IgSankeyChartSkeleton />;
    case GraphType.StackedArea:
      return <IgStackedAreaChartSkeleton />;
    case GraphType.StackedBarHorizontal:
      return (
        <IgHorizStackedBarChartSkeleton useLargeDataset={useLargeDataset} />
      );
    default:
      return (
        <IgBarChartSkeleton config={config} useLargeDataset={useLargeDataset} />
      );
  }
};
